import { denormalize } from 'normalizr'

import { seriesListSchema } from 'client/bookmate/reducers/schemas/schemas'

export function getUserSeries(state) {
  return denormalize(state.user.series, seriesListSchema, state.entities) || {}
}
